import React, { Component } from 'react'
import Fade from 'react-reveal/Fade'

class BusinessData extends Component {

  render() {

    let { title, items, disclaimer } = this.props

    return (
      <section className='business-data'>

        <div className='business-data__inner'>

          <div className='business-data__content'>

            <div className='business-data__heading'>
              <Fade bottom distance='40px' duration={1000}>
              <h5 dangerouslySetInnerHTML={{ __html: title }} />
              </Fade>
            </div>

            { items &&

                <Fade cascade bottom distance='40px' duration={1000}>
                  <div className='business-data__items'>

                    {items.map((el, i) => (

                        <div className='business-data__item' key={i}>

                          <p className='value'>{ el.value }</p>

                          <p className='label' dangerouslySetInnerHTML={{ __html: el.label }} />

                        </div>

                    ))}

                    { disclaimer &&
                      <div className='business-data__disclaimer'>
                        <div dangerouslySetInnerHTML={{ __html: disclaimer }} />
                      </div>
                    }

                  </div>
                </Fade>
            }

          </div>
        </div>
      </section>
    )
  }
}

export default BusinessData
